// removed by extract-text-webpack-plugin
module.exports = {"exampleButton":"___Help__exampleButton___3t1_k","Screenshot":"___Help__Screenshot___2DHY-"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/Help.less
// module id = 1023
// module chunks = 0